"use strict";

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logger = void 0;
exports.Logger = {
  mute: false,
  log: function log(message) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    if (this === null || this === void 0 ? void 0 : this.mute) {
      return;
    }
    console.log.apply(console, __spreadArray([message], args !== null && args !== void 0 ? args : [], false));
  },
  warn: function warn(message) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    if (this === null || this === void 0 ? void 0 : this.mute) {
      return;
    }
    console.warn.apply(console, __spreadArray([message], args !== null && args !== void 0 ? args : [], false));
  },
  info: function info(message) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    if (this === null || this === void 0 ? void 0 : this.mute) {
      return;
    }
    console.info.apply(console, __spreadArray([message], args !== null && args !== void 0 ? args : [], false));
  },
  error: function error(message) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    if (this === null || this === void 0 ? void 0 : this.mute) {
      return;
    }
    console.error.apply(console, __spreadArray([message], args !== null && args !== void 0 ? args : [], false));
  }
};